import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  ControlLabel,
  FormGroup,
  Pagination,
  Modal,
  Tooltip,
} from "react-bootstrap";
import Select from "react-select";
import {
  ChangeSpecialityStatus,
  DeleteSpeciality,
  searchByorgLeadForOrder,
  is_featured_status_change,
  GroupMemberList,
  searchSpeciality,
  AssignLeadToGroup,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import LoadingSpinner from "views/Components/loadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import BootstrapSwitchButton from "react-bootstrap-switch";
import Card from "components/Card/Card.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
class ViewGrops extends Component {
  constructor(props) {
    super(props);
    this.state = {
      couponcode_detail: [],
      couponcode_category_detail: [],
      category: [],
      groupHolders: [],
      category_name: "",
      itemcode: "",
      title: "",
      couponcodecategory: "",
      price: "",
      commision: "",
      unitprice: "",
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      subscriberItems: [],
      loading: false,
      p_couponid: null,
      specilitydata: [],
      page: "",
      _notificationSystem: null,
      alert: null,
      useraccess: "",
      couponcodefile: null,
      city: "0",
      showbulkui: 0,
      noRecordFound: false,
      is_flash_medicine: "",
      is_featured: "",
      city_info: [],
      subscriber: [],
      organizationdetail: [],
      organization: "",
      send_to_all: 0,
      group_id: "",
    };
    this.fileInput = React.createRef();
    this.selectedgroup = this.selectedgroup.bind(this);
    this.deletespeciality = this.deletespeciality.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
    this.handleSwitch.bind(this);
  }

  selectedgroup(cus) {
    localStorage.setItem("specialityID", JSON.stringify(cus));
    this.props.history.push("/admin/editspeciality");
  }

  async componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({
      useraccess: token.role,
    });

    this.searchData();
  }

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  /*
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
    this.searchdata();
  };**/

  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }

  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }

  resetSearch(e) {
    this.setState({
      itemcode: "",
      title: "",
      couponcodecategory: "",
      price: "",
      commision: "",
      unitprice: "",
      city: "0",
    });
    this.searchData();
  }

  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ noRecordFound: false });
    this.setState({ loading: true }, () => {
      searchSpeciality(obj)
        .then((response1) => {
          var data = response1;
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }

          /*   var $no_pages = [];
             let serach_string = "";
             for (var i = 1; i <= data.last_page; i++) {
               if (serach_string == "") {
                 $no_pages.push(i);
               } else {
                 $no_pages.push(i);
               }
             }
   
             if (data.current_page == data.last_page) {
               this.setState({ prevdisabled: null });
               this.setState({ nextdisabled: "1" });
             } else if (data.current_page == 1) {
               this.setState({ nextdisabled: null });
               this.setState({ prevdisabled: "1" });
             } else {
               this.setState({ nextdisabled: null });
               this.setState({ prevdisabled: null });
             }
             if (data.last_page == 1) {
               this.setState({ nextdisabled: 1 });
               this.setState({ prevdisabled: 1 });
             }
             if (data.data.length == 0) {
               $no_pages = [];
               this.setState({ nextdisabled: 1 });
               this.setState({ prevdisabled: 1 });
             }
             this.setState({ currentPage: data.current_page });
             if (data.next_page_url != null) {
               if (serach_string == "") {
                 this.setState({
                   nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
                 });
               } else {
                 this.setState({
                   nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
                 });
               }
             } else {
               this.setState({ nextpage: "#" });
             }
             if (data.prev_page_url != null) {
               if (serach_string == "") {
                 this.setState({
                   prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
                 });
               } else {
                 this.setState({
                   prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
                 });
               }
             } else {
               this.setState({ prevpage: "#" });
             }
             this.setState({ paginationData: $no_pages });
   */

          this.setState({
            loading: false,
            specilitydata: data.data,
          });
        })
        .catch((error) => {
          this.handleNetworkError("bl", error);
        });
    });
  }

  warningWithConfirmAndCancelMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deletespeciality(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this speciality Detail !
        </SweetAlert>
      ),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  deletespeciality(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    DeleteSpeciality(id, obj)
      .then(() => {
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
      });
  }

  addspeciality() {
    this.props.history.push("/admin/addspeciality");
  }

  handleSwitch(e, id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var spstatus = !e.props.value;
    if (spstatus) {
      spstatus = 1;
    } else {
      spstatus = 0;
    }
    ChangeSpecialityStatus(id, spstatus, obj)
      .then((res) => {
        console.log(res);
        this.searchData();
        this.state._notificationSystem.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>{res.data.message}</b>
            </div>
          ),
          level: "success",
          position: "bl",
          autoDismiss: 15,
        });
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
      });
  }

  render() {
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const assign = <Tooltip id="payment">Assign to user</Tooltip>;
    const couponowner = <Tooltip id="couponowner">Assigned to</Tooltip>;
    const specilitydata = this.state.specilitydata;
    const organizationdetail = this.state.organizationdetail;
    var c = 1;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                    {this.state.useraccess == 8 ? (
                      ""
                    ) : (
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          className="text-right"
                        >
                          <Button
                            className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
                            onClick={this.addspeciality.bind(this)}
                          >
                            Add Speciality <i className="fa fa-plus"></i>
                          </Button>
                          <br />
                          &nbsp;
                          {/* <Button  className="fl_mb_web_1 btn-fill fl_mb_1 w_150 " onClick={this.addbulkcouponcode.bind(this)}  bsStyle="info" fill  >Add Bulk couponcode</Button> */}
                        </Col>
                      </Col>
                    )}
                    <br />
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th>Is Active</th>
                            {this.state.useraccess == 1 && (
                              <th className="text-right">Actions</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colSpan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colSpan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {specilitydata.map((cus) => (
                                <tr key={cus.id}>
                                  <td>{cus.title}</td>
                                  <td>
                                    <BootstrapSwitchButton
                                      value={cus.is_active}
                                      onChange={(e) =>
                                        this.handleSwitch(e, cus.id)
                                      }
                                      onColor="info"
                                      onText="Yes"
                                      offText="No"
                                    />
                                  </td>
                                  <td className="td-actions text-right no-padding">
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={edit}
                                    >
                                      <Button
                                        simple
                                        bsStyle="success"
                                        onClick={this.selectedgroup.bind(
                                          this,
                                          cus.id
                                        )}
                                        bsSize="xs"
                                      >
                                        <i className="fa fa-edit" />
                                      </Button>
                                    </OverlayTrigger>

                                    {this.state.useraccess == 1 && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={remove}
                                      >
                                        <Button
                                          simple
                                          bsStyle="danger"
                                          onClick={this.warningWithConfirmAndCancelMessage.bind(
                                            this,
                                            cus.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-times" />
                                        </Button>
                                      </OverlayTrigger>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>
                      {this.state.loading
                        ? ""
                        : this.state.noRecordFound
                        ? ""
                        : ""
                          /*<div style={{ textAlign: "center" }}>
                          <Pagination>
                            <Pagination.First
                              dataurl={this.state.prevpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.prevpage
                              )}
                              disabled={this.state.prevdisabled}
                            />
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                dataurl={url}
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.paginationinfo.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            <Pagination.Last
                              dataurl={this.state.nextpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.nextpage
                              )}
                              disabled={this.state.nextdisabled}
                            />
                          </Pagination>
                        </div>*/
                      }
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(ViewGrops);
